<template>
	<div class="d-flex flex-row justify-space-between align-content-center px-0">
		<botao-tooltip
			v-if="!ata.isLegado"
			icone="mdi-playlist-check"
			v-az-auth="montarPermissoes(permissoes.pedidoUtilizacaoEditar, permissoes.pedidoUtilizacaoVisualizar)"
			cor="grey"
			texto="Ver Pedidos"
			@click="acessarPedido(ata.id, 'editar')"
		></botao-tooltip>
		<botao-tooltip
			v-if="!ata.isLegado"
			icone="mdi-account-group"
			v-az-auth="permissoes.ataOrgaosParticipantes"
			cor="grey"
			texto="Órgãos Participantes"
			@click="abrirModalOrgaosParticipantes(ata.id)"
		></botao-tooltip>
		<botao-tooltip
			v-if="!ata.isLegado"
			icone="mdi-login"
			v-az-auth="montarPermissoes(permissoes.ataEditar, permissoes.ataVisualizar)"
			cor="grey"
			texto="Acessar"
			@click="acessarAta(ata.id, 'editar')"
		></botao-tooltip>
		<botao-tooltip
			v-else
			icone="mdi-login"
			v-az-auth="montarPermissoes(permissoes.ataEditar, permissoes.ataVisualizar)"
			cor="grey"
			texto="Acessar"
			@click="acessarAtaLegado(ata)"
		></botao-tooltip>
	</div>
</template>

<script>
import { actionTypes, routesNames } from '@/core/constants'
import permissoesMixin from '@/views/mixins/permissoes-mixin'
import ComprasLegadoAtaBuscarURLInput from '@/core/apiclient/compras-legado/models/ComprasLegadoAtaBuscarURLInput'

export default {
	name: 'ata-listagem-botoes-acoes',
	mixins: [permissoesMixin],
	props: {
		ata: {
			type: Object,
			required: true,
		},
	},
	methods: {
		acessarAta(idAta) {
			this.$router.push({
				name: routesNames.ATA.ATA_ACESSAR_ITENS_VIEW,
				params: { id: idAta },
			})
		},
		abrirModalOrgaosParticipantes(idAta) {
			this.$emit('abrir-modal-orgaos-participantes', idAta)
		},
		async acessarPedido(idAta) {
			const informacoesAta = await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, idAta)

			if (
				informacoesAta.usuarioPodeVisualizarPedido ||
				informacoesAta.usuariosPodeCriarPedido ||
				informacoesAta.usuarioPermissaoAlterar
			) {
				this.$router.push({
					name: routesNames.ATA.ATA_ACESSAR_GESTAO_PEDIDO_VIEW,
					params: { id: idAta },
				})
			} else {
				this.mostrarNotificacaoWarning('Usuário sem permissão de acesso.')
			}
		},
		async acessarAtaLegado(item) {
			const data = await this.$store.dispatch(
				actionTypes.COMPRAS_LEGADO.BUSCAR_URL_ATA_RP,
				new ComprasLegadoAtaBuscarURLInput(item.id, item.idOrgaoLegado),
			)

			if (data.url) {
				window.open(data.url)
			}
		},
	},
}
</script>

<style scoped></style>
